module.exports = __webpack_public_path__ + "static/reel-pt-e065d2fcb6ae8fd001d4f73fa1bae06f.mp4";